 
            import Vue from "vue"
            import VueCustomElement from "vue-custom-element"
            Vue.use(VueCustomElement);
             
            import index from "./cc-plug/cc-plug.vue"
            Vue.customElement('component-cc-plug', index,{ destroyTimeout: 1200000 });
        